import { render, staticRenderFns } from "./JoinStep.vue?vue&type=template&id=06af01dc&scoped=true&"
import script from "./JoinStep.vue?vue&type=script&lang=js&"
export * from "./JoinStep.vue?vue&type=script&lang=js&"
import style0 from "styles/views/join/joinstep.css?vue&type=style&index=0&id=06af01dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af01dc",
  null
  
)

export default component.exports